import { jsx as o } from "react/jsx-runtime";
import { Select as d } from "@chakra-ui/react";
import { forwardRef as f } from "react";
import { ChevronDownIcon as h } from "../../icons/componentIcons.mjs";
const S = f((t, i) => {
  const { children: n, options: r, size: m = "md", variant: a = "outline", ...c } = t;
  return /* @__PURE__ */ o(
    d,
    {
      ref: i,
      size: m,
      variant: a,
      icon: /* @__PURE__ */ o(h, { variant: "light" }),
      ...c,
      children: r ? r.map(({ disabled: l, key: p, label: s, value: e }) => /* @__PURE__ */ o("option", { disabled: l, value: e, children: s }, p ?? e)) : n
    }
  );
});
S.displayName = "SelectBase";
export {
  S as SelectBase
};
